import { render, staticRenderFns } from "./AdminSettingsPage.vue?vue&type=template&id=269c05ae&scoped=true&"
import script from "./AdminSettingsPage.vue?vue&type=script&lang=js&"
export * from "./AdminSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingsPage.vue?vue&type=style&index=0&id=269c05ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269c05ae",
  null
  
)

export default component.exports